
import { DocumentContentEditor } from "./DocumentContentEditor";

interface ConsultingAgreementViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function ConsultingAgreementView({ content, documentId, onUpdate }: ConsultingAgreementViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Consultant Information</h2>
        <DocumentContentEditor
          section="Consultant Information"
          content={content.consultantInfo}
          documentId={documentId}
          field="consultantInfo"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Client Information</h2>
        <DocumentContentEditor
          section="Client Information"
          content={content.clientInfo}
          documentId={documentId}
          field="clientInfo"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Services Description</h2>
        <DocumentContentEditor
          section="Services Description"
          content={content.servicesDescription}
          documentId={documentId}
          field="servicesDescription"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Deliverables</h2>
        <DocumentContentEditor
          section="Deliverables"
          content={content.deliverables}
          documentId={documentId}
          field="deliverables"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Timeline & Milestones</h2>
        <DocumentContentEditor
          section="Timeline & Milestones"
          content={content.timeline}
          documentId={documentId}
          field="timeline"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Compensation Structure</h2>
        <DocumentContentEditor
          section="Compensation Structure"
          content={content.compensation}
          documentId={documentId}
          field="compensation"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Confidentiality</h2>
        <DocumentContentEditor
          section="Confidentiality"
          content={content.confidentiality}
          documentId={documentId}
          field="confidentiality"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
